import { connect } from 'react-redux';
import { UserSettings } from './UserSettings';
import { AdviserSettings } from './AdviserSettings';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { InstitutionalSettings } from './InstitutionalSettings';

const mapStateToProps = (state) => {
    return { user: state.user, theme: state.theme }
}

const SettingsAccount = ({ user, theme }) => {
    const { t } = useTranslation();
    useDocumentTitle(t('Account Details'));

    if (user?.user?.is_institutional) {
        return <InstitutionalSettings user={user} theme={theme} />;
    } else if (user?.user?.is_adviser) {
        return <AdviserSettings user={user} theme={theme} />;
    } else {
        return <UserSettings user={user} theme={theme} />;
    }
};

export default connect(mapStateToProps, null)(SettingsAccount);
